//#region IMPORTS
import {
  setInstoreTemplateParams,
  clearInstoreTemplateParam,
  clearInstoreTemplateParams,
} from "../../features/instoreTemplates/instoreTemplatesSlice";
import { useAppDispatch, useAppSelector } from "../../store/configureStore";
import { InstoreTemplate } from "../../models/instoreTemplate";
import { ReactNode } from "react";
import MainFilterBarToggleActiveItem from "../_layout/MainFilterBarToggleActiveItem";
import getDistinctValues from "../../helpers/getDistinctValues";
import MainFilterBarItem from "../_layout/MainFilterBarItem";
import MainFilterBar from "../_layout/MainFilterBar";
//#endregion

//#region INTERFACE
interface Props {
  extensionButtons?: ReactNode;
  instoreTemplates: InstoreTemplate[];
}
//#endregion

export default function InstoreTemplatesFilterBar({
  extensionButtons,
  instoreTemplates,
}: Props) {
  //#region SETUP
  // Redux
  const dispatch = useAppDispatch();
  const { page, limit, sort, active, ...params } = useAppSelector(
    ({ instoreTemplates }) => instoreTemplates.instoreTemplate_params
  );
  const { loading } = useAppSelector(
    ({ instoreTemplates }) => instoreTemplates
  );
  //#endregion

  //#region RENDER
  return (
    <MainFilterBar
      paramNamesList={params}
      clearAllFiltersHandler={() => dispatch(clearInstoreTemplateParams())}
      extensionButtons={extensionButtons}
      clearFilterHandler={(paramName: string) => {
        dispatch(clearInstoreTemplateParam(paramName));
        // UX only values cleanup
        paramName === "active_template" &&
          dispatch(clearInstoreTemplateParam("active"));
      }}
      disabled={loading}
    >
      {/* instore_type */}
      <MainFilterBarItem
        filterParameterName="instore_type"
        displayExplanation="Search the instore templates by instore type"
        clearFilterAction={() =>
          dispatch(clearInstoreTemplateParam("instore_type"))
        }
        selectedValue={params.instore_type}
        filterAction={(value: string) =>
          dispatch(setInstoreTemplateParams({ instore_type: value }))
        }
        displayText="Instore type"
        selected={!!params.instore_type}
      />

      {/* order_type */}
      <MainFilterBarItem
        filterParameterName="order_type_instore_name"
        displayExplanation="Filter the orders by order type"
        clearFilterAction={() =>
          dispatch(clearInstoreTemplateParam("order_type_instore_name"))
        }
        selectBoxItems={getDistinctValues(
          instoreTemplates,
          "order_type_instore_name"
        ).filter((item) => item !== null)}
        selectedValue={params.order_type_instore_name}
        filterAction={(value: string) => {
          dispatch(
            setInstoreTemplateParams({ order_type_instore_name: value })
          );
        }}
        displayText="Order type"
        selectBox
        selected={!!params.order_type_instore_name}
      />

      {/* active */}
      <MainFilterBarToggleActiveItem
        clearFilterAction={() => {
          dispatch(clearInstoreTemplateParam("active_template"));
          dispatch(clearInstoreTemplateParam("active"));
        }}
        filterAction={(value?: string) =>
          dispatch(
            setInstoreTemplateParams({
              active: value,
              active_template:
                value === "Yes"
                  ? "Active"
                  : value === "No"
                  ? "Disabled"
                  : undefined,
            })
          )
        }
        selectedValue={params.active}
      />
    </MainFilterBar>
  );
  //#endregion
}
